<template>
  <div class="service_block">
    <div class="left">
      <h3 class="large_blue_label">フルーはCAD作図業務の受発注を支援するサービスです。</h3>
      <p>フルーはCAD作図業務を発注したいクライアントと、受注したいオペレーターのマッチングを行います。</p>
      <p>また、マッチング後のクライアントとオペレーターのメッセージ送受信、ファイル送受信、決済、契約補助などの機能も備えており、初めて契約する相手ともスムーズで安心した取引が出来ます。</p>
      <p class="small_label">契約はクライアントとオペレーターの間で結ばれるため、フルーが契約内容に関寄したり、オペレーターに直接作業指示を出すことはありません。</p>
    </div>
    <div class="right">
      <img class='base_image' src='@/assets/image/pages/information/usages/service_1.png'>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ServiceBlock",
  }
</script>

<style lang="scss" scoped>
  .service_block {
    @include double_columns(30%, 50%);

    .large_blue_label {
      margin-bottom: 2rem;
    }

    @media screen and (max-width: 767px) {
      > .right > .base_image {
        margin: 2rem auto 0 auto;
      }
    }
  }
</style>